import { LS_AD } from 'Constants/ad'
export { LS_AD }
export const LS_0001 = 'dcd_pc_page_main_new'
export const LS_0002 = 'dcd_pc_page_search_result_new'
export const LS_0003 = 'dcd_pc_page_personal_homepage'
export const LS_0004 = 'dcd_pc_page_ugc_detail'
export const LS_0005 = 'dcd_pc_page_feed_article_mix_video'
export const LS_0006 = 'dcd_pc_page_feed_article_mix_article'
export const LS_0007 = 'dcd_pc_page_pgc_article_detail'
export const LS_0008 = 'dcd_pc_page_pgc_video_detail'
export const LS_0009 = 'dcd_pc_page_car_series_pc'
export const LS_0010 = 'dcd_pc_car_series_page'
export const LS_0011 = 'dcd_pc_page_series_real_picture'
export const LS_0012 = 'dcd_pc_page_series_picture_detail'
export const LS_0013 = 'dcd_pc_page_series_configuration'
export const LS_0014 = 'dcd_pc_page_car_series_dcd_score_home'
export const LS_0015 = 'dcd_pc_page_series_article_list'
export const LS_0016 = 'dcd_pc_page_series_video_list'
export const LS_0017 = 'dcd_pc_page_series_instruction_video_detail'
export const LS_0018 = 'dcd_pc_page_series_inquiry  '
export const LS_0019 = 'dcd_pc_page_car_model_comparison'
export const LS_0020 = 'dcd_pc_page_car_zonghe_comparison'
export const LS_0021 = 'dcd_pc_buy_car'
export const LS_0022 = 'dcd_pc_page_car_style_home'
export const LS_0023 = 'dcd_pc_page_reputation_detail'
export const LS_0024 = 'dcd_pc_page_price_calculator'
export const LS_0025 = 'dcd_pc_esc_c2_used_car_source_detail_view_staging'
export const LS_0026 = 'dcd_pc_esc_c2_used_car_source_detail_staging_buy_car'
export const LS_0027 = 'dcd_pc_esc_c2_used_car_source_detail_big_pic'
export const LS_0028 = 'dcd_pc_esc_c2_used_car_source_detail_small_pic'
export const LS_0029 = 'dcd_pc_esc_c2_used_car_source_detail_bottom_pic'
